<template>
    <div class="modal-offers" :class="{ 'is-active': isModalOpen }">
        <div class="modal-offers__backdrop"></div>

        <div class="modal-offers__container">
            <div class="modal-offers__content">
                <div class="modal-offers__box">
                    <button class="modal-offers__btn-close" @click="modalToggle">
                        <img src="/svg/ic_close_orange.svg" alt="close" />
                    </button>

                    <h3>Completa o teu pedido</h3>

<!--                    <p class="sub-title">
                        Temos uma bebida de de oferta para ti, escolhe uma entre as opções
                        abaixo.
                    </p>-->

                    <div class="modal-offers__box-content">
                        <modal-offers-card
                            v-for="(offer, index) in productOffers"
                            :key="index"
                            :product-info="offer"
                        >
                            <button
                                @click="addToCart(offer)"
                                wire:loading.class="disabled"
                                class="btn-bg"
                            >
                                Selecionar
                            </button>
                        </modal-offers-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isModalOpen: false,
            productOffers: null,
            productCartRow: null,
            product: null,
            productSizeSelected: null,
        };
    },
    methods: {
        bodyOverflow() {
            document.querySelector("html").classList.toggle("no-scroll");

            document.querySelector("body").classList.toggle("no-scroll");
        },
        modalToggle() {
            this.isModalOpen = !this.isModalOpen;

            if (!this.isModalOpen) {
                this.clearProductData();
            }

            this.bodyOverflow();
        },
        addToCart(offer) {
            this.isModalOpen = !this.isModalOpen;

            this.bodyOverflow();

            Livewire.emit(
                "addToCart",
                this.product,
                this.productSizeSelected,
                [offer]
            );
            this.clearProductData();
        },
        clearProductData() {
            this.productOffers = null;
            this.productCartRow = null;
            this.product = null;
            this.productSizeSelected = null;
        }
    },
    created() {
        window.addEventListener("chooseProductOfferModal", (event) => {
            //save the event's information into variables
            if (event.detail && event.detail.offers) {
                this.productOffers = event.detail.offers;
            }
            if (event.detail && event.detail.product) {
                this.product = event.detail.product;
            }
            if (event.detail && event.detail.productSizeSelected) {
                this.productSizeSelected = event.detail.productSizeSelected;
            }

            //open modal and hide overflow
            this.isModalOpen = !this.isModalOpen;
            this.bodyOverflow();
        });
    },
};
</script>
